export default class DataWrapper {
    constructor(data= []) {
        this.data=data;
    }

    isPaginated(){
        return false;
    }

    isLastPage(){
        return true;
    }

    getNextPage(){
        return null;
    }

    updateData(data){
        if(data.isPaginated()) //check if new data is Paged
            return data
        else {
            this.data = data.data;
            return this;
        }
    }

    transform(transformFunc){
        this.data = this.data.map(transformFunc)
    }
}